import React from 'react'
import { Link } from 'react-router-dom'
import useMeta from '../hooks/useMeta'

export default function Forbidden() {
  useMeta('Adgang nægtet', 'Adgang nægtet.')
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center bg-brand-light px-6 text-center">
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100 text-red-600 mb-6">
        <i className="fa-solid fa-lock text-4xl"></i>
      </div>
      <h1 className="text-4xl font-extrabold text-brand-navy tracking-tight sm:text-5xl">
        403 - Adgang nægtet
      </h1>
      <p className="mt-4 text-base text-brand-text-muted max-w-md leading-relaxed">
        Du har ikke tilladelse til at tilgå denne side. Hvis du mener, at dette er en fejl, bedes du kontakte vores support.
      </p>
      <div className="mt-8">
        <Link
          to="/"
          className="rounded-lg bg-brand-navy px-6 py-3.5 text-sm font-bold text-white transition-all duration-200 hover:bg-brand-darkblue shadow-md"
        >
          Gå til forsiden
        </Link>
      </div>
    </div>
  )
}
